
import { useUserByIdQuery } from "../../stores/OkOkStore";
import { formatDate } from "../../tools/utils";
import { roleNames, roles } from "../../types/Users";

import { NavLink, useLocation } from "react-router";
import { useAuth } from "../../contexts/auth/useAuth";
import { useTrads } from "../../contexts/trads/useTrads";
import type { ServerFile } from "../../types/ServerFile";
import UserValidation from "../Common/UserValidation";
import { useState } from "react";
import type { LocationState } from "../../types/QueryParameters";
import MessagesList from "../Messages/MessagesList";

function UserItem({userId}:{userId:string}){
    const { data, error, isLoading } = useUserByIdQuery(userId);
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    const {hasRole} = useAuth();
    const {translate}=useTrads();
    const [messages,setMessages]=useState<string[]>([]);

    const [version,setVersion]=useState(0);
    function addMessage(message:string){
        if(!messages.includes(message)){
            setMessages([...messages,message]);
        }
    }

    return (

        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : data ? (
            <div>
                {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_user_update')}</p>}
                {hasRole(roles.Administrators)?
                <nav>
                    <NavLink to={`/user/${userId}/edit`}>{translate('btn_edit')}</NavLink>
                    {data.rangacces==roles.Beneficiaires?
                    <NavLink to={`/user/${userId}/managers`} >{translate('user_managers')}</NavLink>
                    :null}
                
                </nav>
                :null}
                <div className="row">
                    <div className="col-8  mb-3">
                        <dl className="row">

                            <dt className="col-sm-3">{translate('label_id')}</dt>
                            <dd className="col-sm-9">{data.id}</dd>
                            
                            <dt className="col-sm-3">{translate('user_role')}</dt>
                            <dd className="col-sm-9">{roleNames[data.rangacces]}</dd>

                            <dt className="col-sm-3">{translate('user_identifiant')}</dt>
                            <dd className="col-sm-9">{data.identifiant}</dd>
                            <dt className="col-sm-3">{translate('profil_email')}</dt>
                            <dd className="col-sm-9">{data.email}</dd>

                            
                            <dt className="col-sm-3">{translate('profil_civilite')}</dt>
                            <dd className="col-sm-9">{translate(data.civilite)}</dd>

                            <dt className="col-sm-3">{translate('profil_nom')}</dt>
                            <dd className="col-sm-9">{data.nom}</dd>
                            <dt className="col-sm-3">{translate('profil_prenom')}</dt>
                            <dd className="col-sm-9">{data.prenom}</dd>
                            
                            <dt className="col-sm-3">{translate('profil_date_naissance')}</dt>
                            <dd className="col-sm-9">{data.date_de_naissance}</dd>

                            <dt className="col-sm-3">{translate('profil_adresse')}</dt>
                            <dd className="col-sm-9">{data.adresse}</dd>
                            <dt className="col-sm-3">{translate('profil_code_postal')}</dt>
                            <dd className="col-sm-9">{data.code_postal}</dd>

                            <dt className="col-sm-3">{translate('profil_commune')}</dt>
                            <dd className="col-sm-9">{data.commune}</dd>
                            
                            <dt className="col-sm-3">{translate('profil_telephone')}</dt>
                            <dd className="col-sm-9">{data.tel}</dd>
                            
                            <dt className="col-sm-3">{translate('profil_iban')}</dt>
                            <dd className="col-sm-9">{data.iban} <a onClick={()=>{addMessage(translate('profil_error_iban_invalide'))}}><i className="bi bi-exclamation-triangle text-danger"></i></a></dd>                   

                            <dt className="col-sm-3">{translate('profil_num_national')}</dt>
                            <dd className="col-sm-9">{data.numero_national} <a onClick={()=>{addMessage(translate('profil_error_num_national_invalide'))}}><i className="bi bi-exclamation-triangle text-danger"></i></a></dd>                   



                            <dt className="col-sm-3">{translate('label_date_creation')}</dt>
                            <dd className="col-sm-9">{data.date_creation?formatDate(data.date_creation):null}</dd>
                            
                            <dt className="col-sm-3">{translate('label_date_modif')}</dt>
                            <dd className="col-sm-9">{data.date_modif?formatDate(data.date_modif):null}</dd>

                            {hasRole(roles.Administrators)?
                                <>

                                <dt className="col-sm-3">{translate('user_valide')}</dt>
                                <dd className="col-sm-9">{data.validation?"OUI":"Non"}</dd>
                                
                                
                                <dt className="col-sm-3">{translate('profil_rib')}</dt>
                                {data.ribs?.length ?
                                
                                
                                <dd className="col-sm-9">
                                    <ul>
                                    {data.ribs.map((e:ServerFile)=> {
                                    return (<li key={e.id}>
                                        <a href={e.url}> {e.filename}</a>
                                        <a onClick={()=>{addMessage(translate('profil_error_rib_invalide').replace('@filename@',e.filename))}}><i className="bi bi-exclamation-triangle text-danger"></i></a>

                                        </li>)
                                    }
                                    )}
                                    </ul>

                                </dd>
                                :<a onClick={()=>{addMessage(translate('profil_error_rib_requis'))}}><i className="bi bi-exclamation-triangle text-danger"></i></a>}



                                <dt className="col-sm-3">{translate('profil_carte_identite')}</dt>
                                {data.carte_identites?.length?                 
                                <dd className="col-sm-9">
                                    <ul>
                                    {data.carte_identites.map((e:ServerFile)=> {
                                    return (<li key={e.id}>
                                        <a href={e.url}> {e.filename}</a>
                                        <a onClick={()=>{addMessage(translate('profil_error_carte_identite_invalide').replace('@filename@',e.filename))}}><i className="bi bi-exclamation-triangle text-danger"></i></a>
                                        </li>)
                                    }
                                    )}
                                    </ul>

                                </dd>
                                :<a onClick={()=>{addMessage(translate('profil_error_carte_identite_requis'))}}><i className="bi bi-exclamation-triangle text-danger"></i></a>}

                                <dt className="col-sm-3">{translate('profil_reconnaissance_handicap')}</dt>
                                {data.reconnaissances?.length?
                                
                                
                                <dd className="col-sm-9">
                                    <ul>
                                    {data.reconnaissances.map((e:ServerFile)=> {
                                    return (<li key={e.id}>
                                            <a href={e.url}> {e.filename}</a>
                                            <a onClick={()=>{addMessage(translate('profil_error_reconnaissance_handicap_invalide').replace('@filename@',e.filename))}}><i className="bi bi-exclamation-triangle text-danger"></i></a>    
                                        </li>)
                                    }
                                    )}
                                    </ul>

                                </dd>
                                :<a onClick={()=>{addMessage(translate('profil_error_reconnaissance_handicap_requis'))}}><i className="bi bi-exclamation-triangle text-danger"></i></a>}


                                </>
                            :null}

                        </dl>
                    </div>
                    <div className="col-4  mb-3">
                        <UserValidation userParam={data} messages={messages} setMessages={setMessages} version={version} setVersion={setVersion}></UserValidation>
                        <MessagesList topic="user_validation_errors" dest_id={data.id}  version={version} ></MessagesList>
                    </div>
                </div>

            </div>
        ):null
    );
}

export default UserItem;